import auth from '@/router/auth'
import CategoryItemIndex from '@/components/short-links/Index'
import CategoryItemCreate from '@/components/short-links/Create'
import CategoryItemUpdate from '@/components/short-links/Update'
import CategoryItemShow from '@/components/short-links/Show'
import CategoryItemConfig from '@/components/short-links/Config'
import CategoryItemTeacher from '@/components/short-links/Teacher'

export default [
  {
    path: '/short-links',
    name: 'short-links-index',
    component: CategoryItemIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/short-links/create',
    name: 'short-links-create',
    component: CategoryItemCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/short-links/update/:id',
    name: 'short-links-update',
    component: CategoryItemUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/short-links/update-config/:id',
    name: 'short-links-update-config',
    component: CategoryItemConfig,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/short-links/update-teacher/:id',
    name: 'short-links-update-teacher',
    component: CategoryItemTeacher,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/short-links/show/:id',
    name: 'short-links-show',
    component: CategoryItemShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/short-links/router.js